import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import Swal from "sweetalert2";

import TransportesSelector from "./TransportesSelector.js";
import TarjetasSelector from "./TarjetasSelector.js";
import FormaPagoSelector from "./FormaPagoSelector.js";
import BuyerForm from "./BuyerFrom/BuyerForm.js";
import DetalleCompra from "./DetalleCompra/DetalleCompra.js";

import api from "../../../api/api.js";
import apifunctions from "../../../api/functions.js";
import { View } from "../../../../TiendaConfig.js";

const CartDetailed = (props) => {
  const {
    setItem,
    removeItem,
    updateData,
    setCodigoCondicionDePago,
    cartState,
    history,
    removeItems,
    onSuccessfulOrder,
  } = props;

  const [buyer, setBuyer] = useState({});
  const [observaciones, setObservaciones] = useState("");
  const [idTransporte, setIdTransporte] = useState(null);
  const [validaUsuario, setValidaUsuario] = useState(false);
  const [sendingData, setSendingData] = useState(false);
  // const [modified, setModified] = useState(true);
  // const [modalRedirect, setModalRedirect] = useState(false);
  const [loadingFirstUpdate, setLoadingFirstUpdate] = useState(true);

  useEffect(() => {
    document.querySelector("html").scrollTo(0, 0);

    const successCallback = (response) => {
      if (response && response.data) {
        const data = response.data;
        const buyerData = {
          disabled: true,
          Nombre: data.Nombre,
          TipoDoc_id: data.TipoDocumento_id,
          SituacionIVA_id: data.SituacionIVA_id,
          Localidad_id: data.Localidad_id,
          Documento: data.NroDoc,
          DomicilioEntrega: data.DomicilioEntrega,
          Domicilio: data.Domicilio,
          CodPostal: data.CodPostal,
          Telefono: data.Telefono,
          Email: data.Email,
        };
        setBuyer(buyerData);
        setLoadingFirstUpdate(false);
      } else {
        setLoadingFirstUpdate(false);
      }
    };

    const failureCallback = () => {
      setLoadingFirstUpdate(false);
    };

    apifunctions.get(
      api.api.clientes.cliente.perfil,
      null, null, { fields: ["Nombre", "TipoDocumento_id", "NroDoc", "DomicilioEntrega", "Domicilio", "CodPostal", "Telefono", "Localidad", "Email"] },
      successCallback,
      failureCallback,
      failureCallback
    );
  }, []);

  const generarPedido = async () => {
    const result = await Swal.fire({
      title: "¿Cómo deseas realizar el pago?",
      text: "Puedes coordinar el pago con el vendedor o pagar con Mercado Pago.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Mercado Pago",
      cancelButtonText: "Coordinar con el vendedor",
    });

    if (cartState.articulos.length > 0 && validaUsuario) {
      document.querySelector("html").scrollTo(0, 0);
      const toRemove = cartState.articulos
        .filter((art) => art.checked === true)
        .map((x) => ({ code: x.code, talle_id: x.talle_id, color_id: x.color_id }));
      const obj = {
        Observaciones: observaciones ? observaciones : "",
        otrosFacturables: [],
        Articulos: cartState.articulos
          .filter((art) => art.checked === true)
          .map((x) => ({
            Codigo: x.Codigo,
            Cantidad: x.quantity,
            Color_id: x.color_id,
            Talle_id: x.talle_id,
          })),
        idTransporte: idTransporte,
        CodigoCondicionDePago: cartState.CodigoCondicionDePago,
        CodigoPlanPagoConTarjeta: cartState.CodigoPlanPagoConTarjeta,
        clienteAnonimo: buyer,
      };

      setSendingData(true);
      apifunctions.post(
        api.api.ventas.pedidosGenerar,
        null,
        obj,
        (response) => {
          const data = {
            ...response.data,
            mercadopago: result.isConfirmed,
            codigoCondicionDePago: cartState.CodigoCondicionDePago,
          };
          setSendingData(false);
          const callback = () => onSuccessfulOrder && onSuccessfulOrder(data);
          removeItems(toRemove, callback);
        },
        () => setSendingData(false),
        () => setSendingData(false)
      );
    }
  };

  const isDisabledSubmitButton = () => {
    const { total, articulos } = cartState;
    return total === 0 || !validaUsuario || articulos.length === 0 || sendingData;
  };

  const loading = loadingFirstUpdate || cartState.loading;

  return (
    <View.LoadingScreen loading={loading}>
      <div className="container">
        <div className="row esige-cart my-4 p-4 d-flex justify-content-center">
          <div className={loading ? "col-12 vh-100" : "col-12"}>
            <div>
              {!loading && (
                <DetalleCompra
                  cartState={cartState}
                  history={history}
                  onChangeCantidad={({ code, quantity, color_id, talle_id }) =>
                    setItem({ code, quantity, color_id, talle_id }, () => updateData())
                  }
                  removeItem={(code) => removeItem(code, () => updateData())}
                />
              )}
              <div className="col-12">
                <hr />
              </div>
              <FormaPagoSelector
                onChange={(CodigoCondicionDePago) =>
                  setCodigoCondicionDePago(
                    CodigoCondicionDePago,
                    cartState.CodigoPlanPagoConTarjeta,
                    () => updateData()
                  )
                }
              />
              {/* <TarjetasSelector
                CodigoCondicionDePago={cartState.CodigoCondicionDePago}
                total={cartState.total}
                onChange={(CodigoPlanPagoConTarjeta) =>
                  setCodigoCondicionDePago(
                    cartState.CodigoCondicionDePago,
                    CodigoPlanPagoConTarjeta,
                    () => updateData()
                  )
                }
              /> */}
              <TarjetasSelector
                CodigoCondicionDePago={cartState.CodigoCondicionDePago}
                total={cartState.total}
                onChange={(CodigoPlanPagoConTarjeta) =>
                  setCodigoCondicionDePago(
                    cartState.CodigoCondicionDePago,
                    CodigoPlanPagoConTarjeta,
                    () => updateData()
                  )
                }
                onUpdateData={() => updateData()} // ← Agregar esta prop
              />

              <div className="col-12">
                <hr />
              </div>
              {View.TransportesSelector ? (
                <View.TransportesSelector onChange={(id) => setIdTransporte(id)} />
              ) : (
                <TransportesSelector onChange={(id) => setIdTransporte(id)} />
              )}
              <div className="col-12">
                <hr />
              </div>
              {!loadingFirstUpdate && (
                <BuyerForm
                  buyer={buyer}
                  onChange={(isValid, buyerData) => {
                    setValidaUsuario(isValid);
                    setBuyer(buyerData);
                  }}
                />
              )}
              <div className="col-12">
                <hr />
              </div>
              <Observaciones onChange={(obs) => setObservaciones(obs)} />
              <div className="col-12 esige-cart-price my-2 text-center">
                <Button
                  disabled={isDisabledSubmitButton()}
                  color={isDisabledSubmitButton() ? "secondary" : "success"}
                  size="lg"
                  className="btn center-block rounded"
                  onClick={() => generarPedido()}
                >
                  <i className="fa fa-thumbs-up" aria-hidden="true"></i>{" "}
                  Confirmar Orden de Compra
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </View.LoadingScreen>
  );
};

const Observaciones = (props) => {
  return (
    <div>
      <h4 className="color">Observaciones</h4>
      <textarea
        className="form-control"
        rows="1"
        cols="75"
        onChange={(e) => props.onChange && props.onChange(e.target.value)}
        name="Observaciones"
        placeholder="Ingrese aquí sus Observaciones"
      ></textarea>
    </div>
  );
};

export default CartDetailed;
